import { Component, inject, signal } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatIconModule } from '@angular/material/icon'
import { MatDialogModule } from '@angular/material/dialog'
import { ReportClass, ReportView, ReportResult, ScreenUtil } from '@lg/shared'
import { MatSnackBar } from '@angular/material/snack-bar'

export interface ReportExportData {
	reportName: string
}

export type ExportFormat = 'XLSX' | 'CSV' | 'PPTX' | 'PDF'
export type DataScope = 'filtered' | 'all'

@Component({
	selector: 'app-report-export',
	templateUrl: './report-export.component.html',
	styleUrls: ['./report-export.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatIconModule,
		MatDialogModule,
	],
})
export class ReportExportComponent {
	protected dialogRef = inject(DialogRef)
	protected snackBar = inject(MatSnackBar)
	protected data = inject<ReportExportData>(DIALOG_DATA)

	exportFormat = signal<ExportFormat>('XLSX')
	dataScope = signal<DataScope>('filtered')

	exportFormats: ExportFormat[] = ['XLSX', 'CSV', 'PPTX', 'PDF']

	onFormatChange(value: ExportFormat) {
		this.exportFormat.set(value)
	}

	onScopeChange(value: DataScope) {
		this.dataScope.set(value)
	}

	async download() {
		const timeStr = new Date()
			.toISOString()
			.substring(0, 16)
			.replace('T', ' ')
			.replace(':', '-')
		const fileName = `${this.data.reportName} - ${this.dataScope()} - ${timeStr}.${this.exportFormat().toLocaleLowerCase()}`

		// TODO: Implement actual export logic based on format
		const content = new ArrayBuffer(52819)
		ScreenUtil.provideDownload(content, fileName, 'download')

		this.dialogRef.close()
	}

	copyDownloadLink(event: Event) {
		event.preventDefault()
		navigator.clipboard.writeText(window.location.href)
		this.snackBar.open('Download link copied to clipboard', undefined, {
			duration: 2000,
			horizontalPosition: 'center',
		})
	}
}
